// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1fd682de","885":"be953405"}[chunkId] + ".chunk.js";
};